import { fetchSignUpFormQuestions } from 'api/SignUpFormQuestion/Action'

interface Data {
  [subtype: string]: string
}

interface demographicOptions {
  [key: string]: boolean
}

const isActiveQuestions = async (list: string[]) => {
  const demographicStatus: demographicOptions = {}
  list.forEach((item: string) => (demographicStatus[item] = false))
  try {
    const sufData = await fetchSignUpFormQuestions()
    sufData.forEach((item: Data = {}) => {
      if (list.includes(item?.subtype)) demographicStatus[item?.subtype] = true
    })
    return demographicStatus
  } catch (err: any) {
    return err.errors
  }
}

export { isActiveQuestions }
